export enum HandledSentryErrorType {
  UNEXPECTED_API_RESPONSE = 'UNEXPECTED_API_RESPONSE',
}

export enum CustomSentryErrorType {
  I18N_INIT_FAILURE = 'I18N_INIT_FAILURE',
  UNEXPECTED_API_ERROR = 'UNEXPECTED_API_ERROR',
  AUTH_ERROR = 'AUTH_ERROR',
}
